import {createSelector} from '@reduxjs/toolkit';

import {createDestinations} from 'utils/createDestinations';

import {AppState} from '../';
import {marketsSelector} from '../markets/markets.selectors';
import {PropertiesState} from './properties.reducer';
import {Properties} from './properties.interface';

export const propertiesSelector = (state: AppState): PropertiesState =>
  state.properties ?? {};

/**
 * Stable reference so consumers of propertiesDataSelector keep their
 * memoization when there are no properties.
 */
const NO_PROPERTIES: Properties = [];

export const propertiesDataSelector = createSelector(
  propertiesSelector,
  propertiesState =>
    Array.isArray(propertiesState.data) ? propertiesState.data : NO_PROPERTIES
);

export const propertiesLastQueryTimeSelector = createSelector(
  propertiesSelector,
  propertiesState => propertiesState.lastQueryTime
);

export const sortedPropertiesSelector = createSelector(
  propertiesDataSelector,
  properties => properties.slice().sort((a, b) => a.name.localeCompare(b.name))
);

export const createDestinationsSelector = createSelector(
  [propertiesDataSelector, marketsSelector],
  (properties, markets) => createDestinations(markets, properties)
);

export const createSortedDestinationsSelector = createSelector(
  [sortedPropertiesSelector, marketsSelector],
  (properties, markets) => createDestinations(markets, properties)
);

export const propertiesLoadingSelector = createSelector(
  propertiesSelector,
  propertiesState => propertiesState.loading
);

export const propertiesErrorSelector = createSelector(
  propertiesSelector,
  propertiesState => propertiesState.error
);
